import { useMemo } from "react";

export default function Menu({ standing_delete, userType }) {
  const showAction = standing_delete === 1 && userType === 1;

  // 🔹 UseMemo to build menu dynamically — easier to maintain
  const menuItems = useMemo(
    () =>
      [
        { key: "exchange", label: "EXCH", className: "menuExchange small" },
        { key: "master_username", label: "MASTER", className: "menuSymbol small" },
        { key: "username", label: "SUPER", className: "menuSymbol small" },
        { key: "symbol", label: "SYMBOL", className: "menuSymbol small" },
        { key: "expiry", label: "EXPIRY", className: "menuExpiry small" },
        { key: "buySell", label: "BUY/SELL", className: "menuBuyPrice small" },
        { key: "qty", label: "QTY", className: "menuBuyQty small" },
        { key: "rate", label: "RATE", className: "menuSellPrice small" },
        { key: "liveRate", label: "LIVE RATE", className: "menuSellPrice small" },
        { key: "pl", label: "P/L", className: "menuClose small" },
        {
          key: "selfPl",
          label: "SELF P/L",
          className: "menuClose small",
        },
        { key: "lttLut", label: "LTT/LUT", className: "menuLtt small" },
        { key: "date", label: "DATE", className: "menuLtt small" },
        {
          key: "dateUpdate",
          label: "UPDATE",
          className: "menuLtt small",
        },
        { key: "sqOff", label: "SQ-OFF", className: "menuBuyQty small" },
        showAction && {
          key: "action",
          label: "ACTION",
          className: "menuBuyQty small",
        },
      ].filter(Boolean), // remove falsy entries
    []
  );

  return (
    <div className="menuContainer primary white">
      <div className="menuIcon small" />
      {menuItems.map((item) => (
        <div key={item.key} className={item.className}>
          {item.label}
        </div>
      ))}
    </div>
  );
}
